import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    click() {
        const bottomPanel = document.getElementById("additional-info-bottom-panel")

        if (bottomPanel) {
            // Toggle visibility
            bottomPanel.classList.toggle("d-none")

            // Scroll if now visible
            if (!bottomPanel.classList.contains("d-none")) {
                setTimeout(() => {
                    bottomPanel.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    })
                }, 150)
            }
        }
    }
}